import axios, {AxiosInstance} from "axios";
import objectToFormData from "../helpers/objectToFormData";

class ApiService {
    private instance: AxiosInstance;

    constructor() {
        const wrapper = document.getElementById('zr-customizer-wrapper')
        const url = (wrapper && wrapper.dataset.api)
            ? wrapper.dataset.api :
            '/'

        this.instance = axios.create({
            baseURL: url,
        })
    }

    async getArticleDetails(kArtikel: string[]) {
        return this.callApi('articles/' + kArtikel)
    }

    async storeIndividualization(data: {}) {
        return this.callApi('individualization', data, [], 'post')
    }

    async updateIndividualization(id: string|number, data: {}) {
        return this.callApi('individualization/' + id, data, [], 'post')
    }

    async callApi(route: string, data: object = {}, files: Blob[] = [], method = 'get') {
        return await this.instance.request({
            method: method,
            url: route,
            data: objectToFormData({...data, ...files}),
            responseType: "json"
        })
    }
}

export default ApiService;
